import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className={`dark-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        {/* Logo */}
        <div className="logo-container" onClick={() => scrollToSection('hero')}>
          <div className="logo-icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <rect width="40" height="40" rx="8" fill="#00FFD1" fillOpacity="0.1"/>
              <path d="M12 20L18 14L24 20L30 14" stroke="#00FFD1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 26L18 20L24 26L30 20" stroke="#00FFD1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <span className="logo-text">Doctimize</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="dark-nav desktop-nav">
          <a onClick={() => scrollToSection('problem')} className="dark-nav-link">Problem</a>
          <a onClick={() => scrollToSection('solution')} className="dark-nav-link">Lösung</a>
          <a onClick={() => scrollToSection('pricing')} className="dark-nav-link">Preise</a>
          <a onClick={() => scrollToSection('about')} className="dark-nav-link">Über uns</a>
          <a onClick={() => scrollToSection('contact')} className="dark-nav-link">Kontakt</a>
          <a 
            href="https://cal.eu/doctimize/kostenlose-bedarfsabklarung-doctimize"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary header-cta"
          >
            Kostenloses Erstgespräch vereinbaren
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <a onClick={() => scrollToSection('problem')} className="mobile-nav-link">Problem</a>
          <a onClick={() => scrollToSection('solution')} className="mobile-nav-link">Lösung</a>
          <a onClick={() => scrollToSection('pricing')} className="mobile-nav-link">Preise</a>
          <a onClick={() => scrollToSection('about')} className="mobile-nav-link">Über uns</a>
          <a onClick={() => scrollToSection('contact')} className="mobile-nav-link">Kontakt</a>
        </div>
      )}
    </header>
  );
};

export default Header;
